<template>
  <!-- Last update time -->
  <p class="px-3 ma-0 text-xs-left">
    {{ translation('last.update-time') }}
    <span v-if="lastUpdateTime.loader" class="mx-2">
      <v-progress-circular
        indeterminate :width="1" :size="15" color="grey lighten-1">
      </v-progress-circular>
    </span>
    <span v-else ef-feature-id="last-update-time">
      {{ lastUpdateTime.data }}
    </span>
  </p>
</template>

<script>
import { eventBus } from '@/eventBus'
import { mapGetters } from 'vuex'

export default {
  name: 'LastUpdateTime',
  props: {
    dashboardId: { type: String, required: true }
  },
  data () { return {} },
  computed: {
    ...mapGetters(['translation', 'lastUpdateTime'])
  },
  created () {
    eventBus.$on('update-dashboard', () => {
      this.$store.dispatch('fetchLastUpdateTime', {
        filters: this.$store.getters.isGenericGen ? this.$store.getters.selectedFiltersGen : this.$store.getters.selectedFilters,
        dashboardId: this.dashboardId
      })
    })
  },
  destroyed () {
    eventBus.$off('update-dashboard')
  }
}
</script>
